<form
  class="w-100 lty-form lead-form"
  [formGroup]="formGroup"
  *ngIf="ready"
  (ngSubmit)="handleSubmit()"
  [id]="formId"
>
  <div class="modal-body">
    <div class="split-form-body">
      <div
        class="form-group"
        [ngClass]="{
          'flex-basis-50': !isCompanyCustomer,
          'flex-basis-100': isCompanyCustomer,
        }"
      >
        <label i18n>Client</label>
        @if (!customerId) {
          <div>
            <mat-form-field class="lty-input">
              <mat-select formControlName="userId">
                <mat-option *ngFor="let user of users" [value]="user.userId">
                  @if (isCompanyCustomer) {
                    {{ user?.companyDetails?.companyName }}
                  } @else {
                    {{
                      user.firstName +
                        '
                                        ' +
                        user.lastName
                    }}
                  }
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="
                (formGroup.controls['userId'].touched || isSubmitted) &&
                formGroup.controls['userId'].invalid
              "
              class="invalid-feedback"
            >
              <div
                *ngIf="
                  formGroup.controls['userId'].errors &&
                  formGroup.controls['userId'].errors['required']
                "
                i18n
              >
                L'utilisateur est requis
              </div>
            </div>
          </div>
        } @else {
          <div>
            <input
              class="form-control"
              readonly
              [value]="
                isCompanyCustomer
                  ? customer?.companyDetails?.companyName
                  : (customer?.firstName ?? '') +
                    ' ' +
                    (customer?.lastName ?? '')
              "
            />
          </div>
        }
      </div>
      @if (!isCompanyCustomer) {
        <div class="form-group flex-basis-50">
          <label i18n>Membre de la famille</label>
          <div class="position-relative">
            <mat-form-field class="lty-input">
              <mat-select formControlName="memberId">
                <mat-option
                  *ngFor="let member of familyMembers"
                  [value]="member.familyMemberId"
                  >{{ member.firstName + ' ' + member.lastName }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="
                (formGroup.controls['memberId'].touched || isSubmitted) &&
                formGroup.controls['memberId'].invalid
              "
              class="invalid-feedback"
            >
              <div
                *ngIf="
                  formGroup.controls['memberId'].errors &&
                  formGroup.controls['memberId'].errors['required']
                "
                i18n
              >
                Le membre de famille est requis.
              </div>
            </div>
          </div>
        </div>
      }
      <div class="form-group flex-basis-100">
        <label i18n>Type d'assurance</label>
        <div>
          <mat-form-field class="lty-input">
            <mat-select formControlName="insuranceType">
              <mat-option *ngFor="let type of insuranceTypes" [value]="type">{{
                getInsuranceTypeLabel(type)
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="form-group flex-basis-100"
        *ngIf="
          formGroup.controls?.['insuranceType']?.value !== 'CANCELLATION' &&
          formGroup.controls?.['insuranceType']?.value !== 'CENTRALISATION' &&
          formGroup.controls?.['insuranceType']?.value !== 'POLICY_UPDATE'
        "
      >
        <label for="originalProposal" i18n>Police d'origine</label>
        <mat-form-field class="lty-input" id="originalProposal">
          <mat-select formControlName="originalProposalId">
            <mat-option [value]="null" i18n>Aucune</mat-option>
            <mat-option
              *ngFor="let option of userPolicies"
              [value]="option.proposalId"
            >
              {{ getInsuranceTypeLabel(option.insuranceType) }}
              {{
                option.policyDetails?.policyId
                  ? '(' + option.policyDetails?.policyId + ')'
                  : ''
              }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="form-group flex-basis-100 d-flex flex-column"
        *ngIf="formGroup.controls['originalProposalId']?.value"
      >
        <label i18n>Type(s) d'action</label>
        <div class="change-reason-options d-flex flex-wrap">
          <div
            class="form-check change-reason-option d-flex align-items-center"
            *ngFor="let value of LeadChangeReasonValues"
          >
            <input
              type="checkbox"
              [id]="value"
              [checked]="isChangeReasonSelected(value)"
              (change)="toggleChangeReason(value)"
            />
            <label class="form-check-label ps-2 mb-0" [for]="value">
              {{ getLeadChangeReasonLabel(value) }}
            </label>
          </div>
        </div>
        <div class="form-group mt-2" *ngIf="displayReasonFormInput">
          <input
            type="text"
            [(ngModel)]="otherChangeReasonText"
            (ngModelChange)="onOtherChangeReasonTextChange()"
            [ngModelOptions]="{ standalone: true }"
            class="form-control"
          />
        </div>
      </div>

      <div
        class="form-subtitle flex-basis-100 mb-16 text-16"
        *ngIf="
          formGroup.controls['insuranceType'].value != null &&
          formGroup.controls['insuranceType'].value !==
            InsuranceTypeEnum.CENTRALISATION
        "
        i18n
      >
        Informations spécifiques au type d'assurance
      </div>
      <app-lead-health-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.HEALTH ||
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.COMPLEMENTARY_HEALTH
        "
        [familyMembers]="familyMembers"
        [metadata]="lead?.metadata"
        [insuranceType]="formGroup.controls['insuranceType'].value"
      />
      <app-lead-travel-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value === InsuranceTypeEnum.TRAVEL
        "
        [metadata]="lead?.metadata"
      />
      <app-lead-centralisation-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.CENTRALISATION
        "
        [metadata]="lead?.metadata"
        [isCompany]="isCompanyCustomer"
      />
      <app-lead-rc-household-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.RC_HOUSEHOLD
        "
        [metadata]="lead?.metadata"
        [familyMembers]="familyMembers"
      />
      <app-lead-vehicle-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.MOTOR_VEHICLE
        "
        [metadata]="lead?.metadata"
      />
      <app-lead-legal-protection-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.LEGAL_PROTECTION
        "
        [metadata]="lead?.metadata"
      />
      <app-lead-building-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.BUILDING ||
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.BUSINESS_BUILDING
        "
        [metadata]="lead?.metadata"
        [familyMembers]="familyMembers"
        [isCompany]="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_BUILDING
        "
      />
      <app-lead-construction-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.CONSTRUCTION
        "
        [metadata]="lead?.metadata"
        [familyMembers]="familyMembers"
      />
      <app-lead-third-pillar-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.THIRD_PILLAR
        "
        [metadata]="lead?.metadata"
        [familyMembers]="familyMembers"
        [users]="users"
      />
      <app-lead-animal-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value === InsuranceTypeEnum.ANIMAL
        "
        [metadata]="lead?.metadata"
      />
      <app-lead-valuable-objects-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.VALUABLE_OBJECTS
        "
        [metadata]="lead?.metadata"
      />
      <app-lead-housing-rental-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.HOUSING_RENTAL
        "
        [metadata]="lead?.metadata"
      />
      <!-- Business Forms -->
      <app-business-accident-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.BUSINESS_ACCIDENT ||
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.BUSINESS_ACCIDENT_COMPLEMENTARY ||
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.ACCIDENT
        "
        [metadata]="lead?.metadata"
        [userId]="formGroup.controls['userId'].value"
      />
      <app-business-health-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.BUSINESS_HEALTH ||
          formGroup.controls['insuranceType'].value ===
            InsuranceTypeEnum.HEALTH_ALLOWANCE
        "
        [metadata]="lead?.metadata"
        [userId]="formGroup.controls['userId'].value"
      />
      <app-business-retirement-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_RETIREMENT
        "
        [metadata]="lead?.metadata"
        [userId]="formGroup.controls['userId'].value"
      />
      <app-business-things-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_COMPANY_THINGS
        "
        [metadata]="lead?.metadata"
      />
      <app-rc-company-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_RC_COMPANY
        "
        [metadata]="lead?.metadata"
      />
      <app-business-vehicle-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_MOTOR_VEHICLE
        "
        [metadata]="lead?.metadata"
      />
      <app-business-cyber-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_CYBERSECURITY
        "
        [metadata]="lead?.metadata"
      />
      <app-business-legal-protection-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_LEGAL_PROTECTION
        "
        [metadata]="lead?.metadata"
      />
      <app-business-fleet-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_FLEET
        "
        [metadata]="lead?.metadata"
      />
      <app-business-transport-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_TRANSPORT
        "
        [metadata]="lead?.metadata"
      />
      <app-business-technical-installation-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_TECHNICAL_INSTALLATION
        "
        [metadata]="lead?.metadata"
      />
      <app-lead-benefits-account-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BENEFITS_ACCOUNT
        "
        [metadata]="lead?.metadata"
      />
      <app-business-rental-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_RENTAL
        "
        [metadata]="lead?.metadata"
      />
      <app-business-construction-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_CONSTRUCTION
        "
        [metadata]="lead?.metadata"
      />
      <app-business-construction-warranty-form
        #insuranceSpecificForm
        [formGroup]="formGroup"
        *ngIf="
          formGroup.controls['insuranceType'].value ===
          InsuranceTypeEnum.BUSINESS_CONSTRUCTION_WARRANTY
        "
        [metadata]="lead?.metadata"
      />
      <div class="mt-16">
        <div>
          <label i18n>Remarques</label>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="comments"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
      </div>
      <!-- The client decided it would be better to hide this checkbox since when the form is being filled, it's usually when on they're on the phone with the customer so there is no need to have it  
             <div class="mt-16">
                <div class="form-check d-flex gap-1 p-0 d-flex align-items-center">
                    <input type="checkbox" name="sendEmail" id="sendEmail" formControlName="sendEmail" />
                    <label class="form-check-label mb-0" for="sendEmail" i18n>Notifier le client</label>
                </div>
            </div> -->
    </div>
  </div>
</form>
<div
  *ngIf="!ready"
  class="spinner-border text-primary d-flex ms-auto me-auto"
  style="width: 3rem; height: 3rem"
  role="status"
></div>
